import { render } from "./CarouselContainer.vue.js?vue&type=template&id=60799e3b!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainer.vue?vue&type=template&id=60799e3b"
import script from "./CarouselContainer.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainer.vue?vue&type=script&lang=js"
export * from "./CarouselContainer.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/elements/layouts/CarouselContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60799e3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60799e3b', __exports__)) {
    api.reload('60799e3b', __exports__)
  }
  
  module.hot.accept("./CarouselContainer.vue.js?vue&type=template&id=60799e3b!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainer.vue?vue&type=template&id=60799e3b", () => {
    api.rerender('60799e3b', render)
  })

}


export default __exports__